import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  OnInit,
  output,
  signal
} from '@angular/core';

import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { PH_OVERLAY_DATA, PhOverlayRef } from '@ph-core/services/overlay';
import { IconComponent } from '@ph-shared/components/icon/icon-component';
import { PhOptionComponent } from '@ph-shared/components/ph-autocomplete/ph-option/ph-option.component';
import { PhButtonComponent } from '@ph-shared/components/ph-button/ph-button.component';

import { PhNotificationIconComponent } from '../notification-icon/notification-icon.component';
import { getNotificationLevel } from './notification.helpers';
import {
  PhNotificationAction,
  PhNotificationData,
  PhNotificationItem,
  PhNotificationType,
} from './notification.interface';

@Component({
  selector: 'ph-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  imports: [PhNotificationIconComponent, PhButtonComponent, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.ph-dialog-card]': 'card',
    '[class]': 'colorClass',
  }
})
export class PhNotificationComponent implements OnInit {
  get colorClass(): { [klass: string]: boolean } {
    return {
      [getNotificationLevel(this.effectiveType())]: true,
      wideView: this.notification.wideView ?? false,
    };
  }

  card: boolean = true;
  actions = input<PhNotificationAction[]>([]);
  type = input<PhNotificationType>();
  readonly effectiveType = computed(() => this.type() ?? this.notification.type ?? PhNotificationType.info);
  
  duration = input<number>(0);
  standalone = input<boolean>(true);
  value = input<PhNotificationData>({} as PhNotificationData);
  id = input<string>('');

  closed = output<string>();

  notification = inject<PhNotificationItem>(PH_OVERLAY_DATA);
  private ref = inject<PhOverlayRef<PhNotificationComponent>>(PhOverlayRef);

  notificationValue = signal<PhNotificationData | undefined>(this.notification.value as PhNotificationData);
  displayValue = computed(() => this.notificationValue() || this.value());

  ngOnInit(): void {
    if (this.duration() > 0) {
      of([])
        .pipe(delay(this.duration()))
        .subscribe(() => this.close());
    }
  }

  act(
    action: ((ref: PhOverlayRef<PhOptionComponent> | PhNotificationComponent) => void) | undefined
  ): void {
    if (action) {
      action((this.standalone() ? this.ref : this) as PhNotificationComponent | PhOverlayRef<PhOptionComponent>);
    }
  }

  update(value: PhNotificationItem) {
    Object.assign(this.notification.value, value);
    this.notificationValue.set({ ...this.notification.value });
  }

  close(): void {
    if (this.standalone()) {
      this.ref.close();
    } else {
      this.closed.emit(this.id());
    }
  }
}
